<template>
    <div class="container">
        <!-- Academic Year Dropdown -->
        <b-form-group>
            <label class="required-label">Academic Year:</label>
            <b-form-select :options="$acedemicYears" v-model="academic_year" />
        </b-form-group>

        <!-- Programme Dropdown (visible only after selecting year) -->
        <b-form-group v-if="academic_year">
            <label class="required-label">Programme:</label>
            <b-form-select :options="usergroups" v-model="usergroup_id" />
        </b-form-group>

        <!-- Submit Button -->
        <div class="text-right mt-3">
            <b-button variant="success" size="md" @click="moveStudentsToSelectedProgramme" :disabled="!usergroup_id">
                Move To Programme
            </b-button>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    props: ["publicusers"],
    data() {
        return {
            academic_year: null,
            usergroup_id: null,
            usergroups: [], // List of programmes
        };
    },
    created() {
        this.fetchUserGroups();
    },
    methods: {
        // Move selected students to chosen programme
        async moveStudentsToSelectedProgramme() {
            const applicationIds = this.publicusers.map(user => user.id);
            const url = `${this.$store.getters.getAPIKey.mainAPI}/admissionforms/updateapplications/${this.usergroup_id}`;
            try {
                await axios.post(url, { applicationIds });
                this.$toast.success("Successfully moved to programme.", { position: "top", duration: 3000 });
                this.$emit("close"); // Close modal or parent popup
            } catch (error) {
                console.error("Error moving students:", error);
                this.$toast.error("An error occurred while moving students.");
            }
        },
        // Load list of usergroups/programmes
        async fetchUserGroups() {
            const url = `${this.$store.getters.getAPIKey.mainAPI}/usergroups?allusergroups=1`;
            try {
                const response = await this.$axios.get(url);
                this.usergroups = response.data.map(group => ({
                    value: group.id,
                    text: `${group.name} (${group.code}${group.scheme ? ` - ${group.scheme} Scheme` : ""})`,
                }));
            } catch (error) {
                console.error("Error fetching usergroups:", error);
                this.$toast.error("Failed to load programme list.");
            }
        }
    },
};
</script>